import { Link } from 'react-router-dom'
import { 
  FiHome, 
  FiFileText,
  FiTerminal,
  FiImage,
  FiSettings,
  FiActivity 
} from 'react-icons/fi'

export default function Sidebar() {
  return (
    <div className="w-64 bg-white h-screen p-6 border-r">
      <div className="flex flex-col items-center gap-2 mb-8">
        <img 
          src="/logo.png" 
          alt="Logo" 
          className="w-48 h-20 object-contain mb-2" // Increased size and added margin
        />
        <h1 className="text-2xl font-bold mb-8 flex items-center gap-2">
          <span className="text-[#581745]">WABA BACKEND</span>
        </h1>
      </div>

      <nav className="space-y-2">
        <div className="text-sm font-medium text-gray-500 mb-4">MAIN MENU</div>

        <Link to="/dashboard" className="flex items-center gap-3 p-2 text-gray-600 hover:bg-gray-50 rounded-lg font-semibold">
          <FiHome className="text-lg" />
          Dashboard
        </Link>

        <Link to="/templates" className="flex items-center gap-3 p-2 text-gray-600 hover:bg-gray-50 rounded-lg font-semibold">
          <FiFileText className="text-lg" />
          Templates
        </Link>

        <Link to="/test-api" className="flex items-center gap-3 p-2 text-gray-600 hover:bg-gray-50 rounded-lg font-semibold">
          <FiTerminal className="text-lg" />
          Test API
        </Link>

        {/* New Media Handler Link */}
        <Link to="/media" className="flex items-center gap-3 p-2 text-gray-600 hover:bg-gray-50 rounded-lg font-semibold">
          <FiImage className="text-lg" />
          Media Handler
        </Link>

        <Link to="/settings" className="flex items-center gap-3 p-2 text-gray-600 hover:bg-gray-50 rounded-lg font-semibold">
          <FiSettings className="text-lg" />
          Settings
        </Link>

        <Link to="/logs" className="flex items-center gap-3 p-2 text-gray-600 hover:bg-gray-50 rounded-lg font-semibold">
          <FiActivity className="text-lg" />
          Analytics
        </Link>

        <Link to="/scheduler" className="flex items-center gap-3 p-2 text-gray-600 hover:bg-gray-50 rounded-lg font-semibold">
          <FiActivity className="text-lg" />
          Scheduler
        </Link>
      </nav>
    </div>
  )
}